import * as moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { addFrameScoresAction } from "./matchScoreAction";
import Break from './break';
import { cloneDeep } from 'lodash';
import UtilService from "../../container/utils/utils";
import { toast } from "react-toastify";


class UpdateScore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isClosing: false,
      btnDis: false,
      error: "",
    };
  }

  modalClose = (closeBtn) => {
    this.setState({ isClosing: true });
    setTimeout(() => {
      this.setState({ isClosing: false });
      this.props.onUpdateScoreModal();

    }, 1000);
    if (closeBtn) {
      this.props.onResetUpdatedScore();
    }
  };

  stopPropagation = (event) => {
    event.stopPropagation();
    event.preventDefault();
    console.log('this is working');
  };

  formatTime = (timestamp) => {
    return moment(timestamp).format("h:mm A");
  };

  formatDuration = (duration) => {
    const durationMoment = moment.duration(duration);
    const hours = durationMoment.hours();
    const minutes = durationMoment.minutes();
    const seconds = durationMoment.seconds();

    let totalMinutes = hours * 60 + minutes;
    let durationString = "";

    let roundMin = 0;
    if (totalMinutes > 0) {
      if (seconds > 0) {
        roundMin = totalMinutes + seconds / 60;
      } else {
        roundMin = totalMinutes;
      }
    }

    if (totalMinutes > 0 || seconds > 0) {
      durationString =
        totalMinutes === 0
          ? `${seconds < 10 ? "0" : ""}${seconds} Sec`
          : `${Math.round(roundMin)} Mins`;
    } else {
      durationString = "00 Mins";
    }

    return durationString;
  };

  updateScoreFunc = async () => {
    this.setState({ btnDis: true })
    const { matchDetails, frameDetails } = this.props;
    const { matchId } = matchDetails;

    let frames = [];

    for (let i = 0; i < frameDetails.length; i++) {
      const player1BreaksList = frameDetails[i]?.player1HighBreaks;
      const player2BreaksList = frameDetails[i]?.player2HighBreaks;
      const player1BallPoints = frameDetails[i]?.player1BallPoints;
      const player2BallPoints = frameDetails[i]?.player2BallPoints;

      const totalOfBreaks1 = player1BreaksList.reduce((acc, curr) => acc + curr, 0);
      const totalOfBreaks2 = player2BreaksList.reduce((acc, curr) => acc + curr, 0);
      
      const warnings = [
          { totalBreaks: totalOfBreaks1, playerScore: frameDetails[i]?.player1Score, error: `player1Error${i}` },
          { totalBreaks: totalOfBreaks2, playerScore: frameDetails[i]?.player2Score, error: `player2Error${i}` },
      ];
      
      for (const { totalBreaks, playerScore, error } of warnings) {
          if (totalBreaks > playerScore) {
              toast.error(`The total score should not be less than the total of breaks.`);
              this.setState({ btnDis: false, error });
              return;
          }
      }      

      let framesObj = {
        player1Breaks: player1BreaksList ? player1BreaksList : [],
        player2Breaks: player2BreaksList ? player2BreaksList : [],
        player1BallPoints: player1BallPoints ? player1BallPoints : [],
        player2BallPoints: player2BallPoints ? player2BallPoints : [],
        player1Score: frameDetails[i]?.player1Score ? frameDetails[i]?.player1Score : 0,
        player2Score: frameDetails[i]?.player2Score ? frameDetails[i]?.player2Score : 0,
      };
      frames.push(framesObj);
    }
    let dataParam = { matchId: matchId, frame: frames };
    await this.props.dispatch(addFrameScoresAction(dataParam));

    const { addFrameScoresSuccess, addFrameScoresData, addFrameScoresFail } =
      this.props.apiReducer;
    if (addFrameScoresSuccess && addFrameScoresData) {
      this.modalClose(false);
      this.props.onUpdateScoreSuccess(this.props.matchScore, true);
    }
    setTimeout(() => {
      this.setState({ btnDis: false });
    }, 1000);
  };

  handleChange = (e, player, frameNumber) => {
    const { name, value } = e.target;
    const updatedFrames = cloneDeep(this.props.frameDetails);
    // Replace consecutive commas with a single comma
    const sanitizedValue = value.replace(/[^\d,]+/g, "").replace(/,+/g, ",");

    // Check if there's only one group of 3 digits
    if (sanitizedValue.match(/^\d{1,3}$/)) {
      updatedFrames[frameNumber][name] = sanitizedValue;
    } else {
      // Check if the value after the last comma is more than 3 digits
      const parts = sanitizedValue.split(",");
      const lastPart = parts[parts.length - 1];
      if (lastPart.length > 3) {
        // If more than 3 digits, truncate the value after the last comma
        const truncatedValue =
          parts.slice(0, -1).join(",") != ""
            ? parts.slice(0, -1).join(",") + "," + lastPart.slice(0, 3)
            : lastPart.slice(0, 3);
        updatedFrames[frameNumber][name] = truncatedValue;
      } else {
        updatedFrames[frameNumber][name] = sanitizedValue;
      }
    }

    this.props.updateFrameScore(updatedFrames, player, frameNumber);
  };

  resetFrame = (index, player) => {
    const { frameDetails, matchScore, matchDetails } = this.props;
    const preFrameDetails = cloneDeep(this.props.preFrameDetails);
    const { scoreMode } = matchScore;
    const updatedFrames = cloneDeep(frameDetails);

    if (player === 1 || player === 2) {
      const playerKey = `player${player}Breaks`;
      updatedFrames[index][playerKey] = preFrameDetails[index][playerKey];
      if (scoreMode === "NORMAL") {
        const playerKey2 = `player${player}BallPoints`;
        const playerKey3 = `player${player}HighBreaks`;
        updatedFrames[index][playerKey2] = preFrameDetails[index][playerKey2];
        updatedFrames[index][playerKey3] = preFrameDetails[index][playerKey3];
      }

      if (matchDetails) {
        const { scoreBy, statusId } = matchDetails;
        if (scoreBy === "WEB_APP" || scoreMode == "SIMPLIFI") {
          const playerKey4 = `player${player}Score`;
          updatedFrames[index][playerKey4] = preFrameDetails[index][playerKey4];
        }
      }    
      this.props.updateFrameScore(updatedFrames, player, index);
    }

  };

  restrictFrameDecimal = (event) => {
    if (event.which === 46 || event.which === 101) {
      event.preventDefault();
    }
  };

  restrict = (event) => {
    console.log(event.which);
    let key = event.which;
    if (key < 44 || key == 45 || key == 46 || key == 47 || key > 57) {
      event.preventDefault();
    }
  };

  ballIncrement = (ball, breakNumber, frameNumber, player) => {
    const frameDetails = cloneDeep(this.props.frameDetails);
    const playerKey = player === "1" ? "player1BallPoints" : "player2BallPoints";
    frameDetails[frameNumber][playerKey][breakNumber].push(ball);
    this.props.updateFrameScore(frameDetails, player, frameNumber, breakNumber);
  }

  ballDecrement = (ball, breakNumber, frameNumber, player) => {
    const frameDetails = cloneDeep(this.props.frameDetails);
    const playerKey = player === "1" ? "player1BallPoints" : "player2BallPoints";
    const index = frameDetails[frameNumber][playerKey][breakNumber].lastIndexOf(ball);
    if (index !== -1) {
      frameDetails[frameNumber][playerKey][breakNumber].splice(index, 1);
    } else {
      console.error("Ball not found in array.");
    }
    this.props.updateFrameScore(frameDetails, player, frameNumber, breakNumber);
  }

  addBreak = (player, frameNumber) => {
    const updatedFrames = cloneDeep(this.props.frameDetails);
    const playerKey = player === "1" ? "player1BallPoints" : "player2BallPoints";
    let frame = updatedFrames[frameNumber];
    const playerKey2 = player === "1" ? "player1HighBreaks" : "player2HighBreaks";
    if (frame[playerKey]) {
      frame[playerKey].push([0]);
      frame[playerKey2].push(0);
    } else {
      frame[playerKey] = [[0]];
      frame[playerKey2] = [0];
    }

    this.props.updateFrameScore(updatedFrames, player, frameNumber, null);
  }

  handlePlayerScore = (e, frameNumber) => {
    this.setState({ error: "" });
    const { value, name } = e.target;
    if (value.length > 4) {
        return;
    }
    const updatedFrames = cloneDeep(this.props.frameDetails);
    const player = name === "player1Score" ? 1 : 2;

    if (name === "player1Score") {
        updatedFrames[frameNumber].player1Score = value;
    } else {
        updatedFrames[frameNumber].player2Score = value;
    }
    
    if (value === "" || value > 0) {
        this.props.updateFrameScore(updatedFrames, player, frameNumber);
    }
}

  render() {
    const { matchDetails, frameDetails, matchScore, timeZone } = this.props;
    const { scoreMode, statusId, player2profileImage, player1profileImage } = matchScore;
    const { btnDis } = this.state;


    let isWebAppScoring = false;
    if (matchDetails) {
      const { statusId, scoreBy, scoreMode } = matchDetails;
      if (scoreBy === "WEB_APP" || scoreMode == "SIMPLIFI") {
        isWebAppScoring = true;
      }
    }

    return (
      <>
        <div
          className={`modal show customModal animated ${this.state.isClosing ? "closing" : ""
            }`}
          id="tournamentDetails"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="tournamentDetailsLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div
              className="white-container"
              id="whiteContainer"
            >
              <div id="addTopHeading">
                <div className="updated-header d-flex justify-content-between">
                  <div className="col-4 pl-0">
                    <div className="back" onClick={() => this.modalClose(true)}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="19.5"
                        height="16.121"
                        viewBox="0 0 19.5 16.121"
                      >
                        <g id="arrow-left" transform="translate(-4.25 -3.939)">
                          <path
                            id="Path_5448"
                            data-name="Path 5448"
                            d="M18,0H0"
                            transform="translate(5 12)"
                            fill="none"
                            stroke="#2d3c25"
                            strokeLinecap="round"
                            strokeWidth="1.5"
                          />
                          <path
                            id="Path_5406"
                            data-name="Path 5406"
                            d="M12,19,5,12l7-7"
                            fill="none"
                            stroke="#2d3c25"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.5"
                          />
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="table-data d-flex justify-content-center flex-column align-items-center">
                      <div className="title">{matchDetails.matchName}  ({matchDetails.tableName})</div>
                      <div className="date-time">
                        <span className="text-light-gray">
                          Scheduled date & time:
                        </span>{" "}
                        <span className="text-red">
                          {UtilService.getZonedTime(matchDetails.scheduleTime, timeZone)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-4 pr-0">
                    <div className="btn-col d-flex justify-content-end">
                      <div
                        className={`expand-btn d-block position-static d-flex ${btnDis ? "disable-edit-delete" : ""}`}
                        onClick={() => this.props.onResetUpdatedScore()}>
                        Reset
                      </div>
                      <div
                        className={`add-club ${btnDis ? "disable-edit-delete" : ""}`}
                        onClick={this.updateScoreFunc}>
                        Update
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tableView" style={{ marginTop: "11px" }}>
                  <table className="table mb-0">
                    <thead>
                      <tr className="top-head">
                        <td width="50%">
                          <div className="left-player player-details d-flex flex-column align-items-end">
                            <div className="d-flex align-items-center info-left">
                              <div className="content-left d-flex flex-column align-items-end">
                                <div className="player-name">Player A</div>
                                <div className="title">
                                  {matchDetails.playerName1}{" "}
                                </div>
                                <div className="country text-right">
                                  {matchDetails.player1Country && (
                                    <span>(</span>
                                  )}
                                  {matchDetails.player1Country}
                                  {matchDetails.player1Country && (
                                    <span>)</span>
                                  )}
                                </div>
                              </div>
                              <figure>
                                <img
                                  src={matchDetails.player1profileImage ? matchDetails.player1profileImage : player1profileImage}
                                  alt=""
                                ></img>
                              </figure>
                            </div>
                          </div>
                        </td>
                        <td width="50%">
                          <div className="right-player player-details d-flex flex-column align-items-start">
                            <div className="d-flex align-items-center info-left">
                              <figure>
                                <img
                                  src={matchDetails.player2profileImage ? matchDetails.player2profileImage : player2profileImage}
                                  alt=""
                                ></img>
                              </figure>
                              <div className="content-right d-flex flex-column align-items-start">
                                <div className="player-name">Player B</div>
                                <div className="title">
                                  {matchDetails.playerName2}{" "}
                                </div>
                                <div className="country text-left">
                                  {matchDetails.player2Country && (
                                    <span>(</span>
                                  )}
                                  {matchDetails.player2Country}
                                  {matchDetails.player2Country && (
                                    <span>)</span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </thead>
                  </table>
                </div>
                <div
                  class="tab-content team-content mt-3"
                  id="Tournament-Details"
                >
                  <div className="table-responsive table-score-m-h">
                    {((statusId == 1 && scoreMode === null) || scoreMode === "SIMPLIFI") && frameDetails &&
                      frameDetails.map((frame, frameNumber) => {
                        return (
                          <table className="table mb-0" key={frameNumber}>
                            <thead>
                              <tr className="match-time-row">
                                <th
                                  scope="col"
                                  colSpan="2"
                                  className="text-capitalize"
                                >
                                  <div className="d-flex flex-row justify-content-between align-items-center">
                                    <div>
                                      <span className="mr-2"></span> Frame{" "}
                                      {frameNumber + 1}
                                    </div>
                                    <div className="frame-diff">
                                      (
                                      {frame.player1FrameDifference
                                        ? frame.player1FrameDifference
                                        : 0}
                                      /
                                      {frame.player2FrameDifference
                                        ? frame.player2FrameDifference
                                        : 0}
                                      )<span className="ml-2"></span>
                                    </div>
                                    <div>
                                    </div>
                                  </div>
                                </th>
                              </tr>
                            </thead>
                            <tbody className="frame-card">
                              <tr className="matchs-players" key={1}>
                                <td className="match-player-schedule match-update-score">
                                  <textarea
                                    className={`cus-form-control he-auto ${this.state.error === `player1Error${frameNumber}`
                                    ? "input-error"
                                    : ""
                                    }`}
                                    name="player1Breaks"
                                    id="player1Breaks"
                                    cols="30"
                                    rows="2"
                                    value={frame.player1Breaks}
                                    onChange={(e) =>
                                      this.handleChange(e, 1, frameNumber)
                                    }
                                    onKeyPress={this.restrictFrameDecimal}
                                    onKeyDown={(evt) =>
                                      ["e", "E", "+", "-"].includes(evt.key) &&
                                      evt.preventDefault()
                                    }
                                    placeholder={isWebAppScoring ? `Enter High Breaks for ${matchDetails.playerName1} here...` : `Enter points for ${matchDetails.playerName1} here...`}
                                  ></textarea>
                                  <div className={`d-flex bottom ${isWebAppScoring ? "align-items-between" : "align-items-center"}`}>
                                  {!isWebAppScoring && 
                                    <>
                                    Foul Earned : <span className="text-green">{frame.player1FoulEarned && frame.player1FoulEarned.length > 0 ? frame.player1FoulEarned.reduce((acc, curr) => acc + curr, 0) : 0} Points</span>
                                    </>}
                                    <div className={`d-flex align-items-center ${isWebAppScoring ? "" : "ml-auto"}`}>Total Score :

                                      {isWebAppScoring ?
                                        <input type="number"
                                        className={`cus-form-control scoreInput ${this.state.error === `player1Error${frameNumber}`
                                        ? "input-error"
                                        : ""
                                        }`}
                                        name="player1Score"
                                          value={frame.player1Score ? frame.player1Score : 0}
                                          onChange={(e) => this.handlePlayerScore(e, frameNumber)}
                                        />
                                        :
                                        <span className="red-txt">
                                          {frame.player1Score
                                            ? frame.player1Score
                                            : 0}
                                        </span>
                                      }

                                      <span className="ml-2" onClick={() => this.resetFrame(frameNumber, 1)}>
                                        <svg viewBox="0 0 31.99983 27"><g data-name="Layer 2" id="Layer_2"><g id="Interface-Solid"><path fill="#666666" d="M18.45783,0A13.53082,13.53082,0,0,0,4.92713,13.29712l-.0025.01245v.03662c-.00061.05176-.00781.10205-.00781.15381,0,.01367.00738.02515.00781.03857v4.48975L2.16,15.09277A1.25042,1.25042,0,1,0,.33967,16.80762l4.9248,5.22949c.00458.00488.01117.00635.01581.011l.0279.02734c.00469.00464.00616.011.011.01538a1.20328,1.20328,0,0,0,.18605.11743,1.21223,1.21223,0,0,0,.17328.1167l.00927.00635c.0058.00244.01288.00146.01874.00391a1.20844,1.20844,0,0,0,.93744-.00025l.01855-.00439.00666-.0044a1.20765,1.20765,0,0,0,.16632-.1123,1.1717,1.1717,0,0,0,.19659-.124c.005-.00463.00647-.01123.01135-.01611l.02717-.02783c.00445-.00488.0108-.00611.01519-.01074l4.90821-5.2295a1.24979,1.24979,0,1,0-1.82227-1.71093L7.42463,18.02148v-4.675A11.03794,11.03794,0,1,1,18.45783,24.5a1.25,1.25,0,0,0,0,2.5,13.50007,13.50007,0,1,0,0-27Z" id="interface-solid-multimedia-refresh-button" /></g></g></svg>
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td className="match-player-schedule match-update-score">
                                  <textarea
                                    className={`cus-form-control he-auto ${this.state.error === `player2Error${frameNumber}`
                                    ? "input-error"
                                    : ""
                                    }`}
                                    name="player2Breaks"
                                    id="player2Breaks"
                                    cols="30"
                                    rows="2"
                                    value={frame.player2Breaks}
                                    onChange={(e) =>
                                      this.handleChange(e, 2, frameNumber)
                                    }
                                    onKeyPress={this.restrictFrameDecimal}
                                    onKeyDown={(evt) =>
                                      ["e", "E", "+", "-"].includes(evt.key) &&
                                      evt.preventDefault()
                                    }
                                    placeholder={isWebAppScoring ? `Enter High Breaks for ${matchDetails.playerName2} here...` : `Enter points for ${matchDetails.playerName2} here...`}
                                  ></textarea>
                                  <div className="d-flex bottom align-items-center">
                                    Total Score :
                                    {isWebAppScoring ?
                                      <input type="number"
                                        className={`cus-form-control scoreInput ${this.state.error === `player2Error${frameNumber}`
                                        ? "input-error"
                                        : ""
                                        }`}
                                        name="player2Score"
                                        value={frame.player2Score ? frame.player2Score : 0}
                                        onChange={(e) => this.handlePlayerScore(e, frameNumber)}
                                      />
                                      :
                                      <span className="red-txt">
                                        {frame.player2Score
                                          ? frame.player2Score
                                          : 0}
                                      </span>
                                    }
                                    <span className="ml-2" onClick={() => this.resetFrame(frameNumber, 2)}>
                                      <svg viewBox="0 0 31.99983 27"><g data-name="Layer 2" id="Layer_2"><g id="Interface-Solid"><path fill="#666666" d="M18.45783,0A13.53082,13.53082,0,0,0,4.92713,13.29712l-.0025.01245v.03662c-.00061.05176-.00781.10205-.00781.15381,0,.01367.00738.02515.00781.03857v4.48975L2.16,15.09277A1.25042,1.25042,0,1,0,.33967,16.80762l4.9248,5.22949c.00458.00488.01117.00635.01581.011l.0279.02734c.00469.00464.00616.011.011.01538a1.20328,1.20328,0,0,0,.18605.11743,1.21223,1.21223,0,0,0,.17328.1167l.00927.00635c.0058.00244.01288.00146.01874.00391a1.20844,1.20844,0,0,0,.93744-.00025l.01855-.00439.00666-.0044a1.20765,1.20765,0,0,0,.16632-.1123,1.1717,1.1717,0,0,0,.19659-.124c.005-.00463.00647-.01123.01135-.01611l.02717-.02783c.00445-.00488.0108-.00611.01519-.01074l4.90821-5.2295a1.24979,1.24979,0,1,0-1.82227-1.71093L7.42463,18.02148v-4.675A11.03794,11.03794,0,1,1,18.45783,24.5a1.25,1.25,0,0,0,0,2.5,13.50007,13.50007,0,1,0,0-27Z" id="interface-solid-multimedia-refresh-button" /></g></g></svg>
                                    </span>
                                    {!isWebAppScoring && <div className="ml-auto">Foul Earned : <span className="text-green">{frame.player2FoulEarned && frame.player2FoulEarned.length > 0 ? frame.player2FoulEarned.reduce((acc, curr) => acc + curr, 0) : 0} Points</span></div>}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        );

                      })}
                    {scoreMode === "NORMAL" && frameDetails &&
                      frameDetails.map((frame, frameNumber) => {
                        return (
                          <table className="table mb-0" key={frameNumber}>
                            <thead>
                              <tr className="match-time-row">
                                <th
                                  scope="col"
                                  colSpan="2"
                                  className="text-capitalize text-center position-realtive "
                                >
                                  <span className="team">Frame{" "}{frameNumber + 1}</span>
                                  (
                                  {frame.player1FrameDifference
                                    ? frame.player1FrameDifference
                                    : 0}
                                  /
                                  {frame.player2FrameDifference
                                    ? frame.player2FrameDifference
                                    : 0}
                                  )
                                </th>
                              </tr>
                            </thead>
                            <tbody className="frame-card">
                              <tr className="matchs-players pro-matchs-players">
                                <td className="pro-match-update pr-20 br-1">
                                  <div className="d-flex flex-wrap custom-width-col-1">
                                    <Break
                                      player="1"
                                      key={"addBreakPlayer1"}
                                      frameNumber={frameNumber}
                                      isBreakAdd={true}
                                      addBreak={this.addBreak}
                                    />
                                    {frame.player1BallPoints && frame.player1BallPoints.map((ballsPoint, breakNumber) => {
                                      return (
                                        <Break
                                          player="1"
                                          key={breakNumber}
                                          balls={ballsPoint}
                                          breakNumber={breakNumber}
                                          frameNumber={frameNumber}
                                          ballIncrement={this.ballIncrement}
                                          ballDecrement={this.ballDecrement}
                                        />
                                      )
                                    })
                                    }
                                  </div>
                                  <div className="d-flex bottom align-items-center">
                                    Foul Earned : <span className="text-green">{frame.player1FoulEarned && frame.player1FoulEarned.length > 0 ? frame.player1FoulEarned.reduce((acc, curr) => acc + curr, 0) : 0} Points</span>
                                    <div className={`d-flex align-items-center ${isWebAppScoring ? "" : "ml-auto"}`}>Total Score : <span className="red-txt">
                                      {frame.player1Score
                                        ? frame.player1Score
                                        : 0}
                                    </span>
                                      <span onClick={() => this.resetFrame(frameNumber, 1)}>
                                        <svg viewBox="0 0 31.99983 27"><g data-name="Layer 2" id="Layer_2"><g id="Interface-Solid"><path fill="#666666" d="M18.45783,0A13.53082,13.53082,0,0,0,4.92713,13.29712l-.0025.01245v.03662c-.00061.05176-.00781.10205-.00781.15381,0,.01367.00738.02515.00781.03857v4.48975L2.16,15.09277A1.25042,1.25042,0,1,0,.33967,16.80762l4.9248,5.22949c.00458.00488.01117.00635.01581.011l.0279.02734c.00469.00464.00616.011.011.01538a1.20328,1.20328,0,0,0,.18605.11743,1.21223,1.21223,0,0,0,.17328.1167l.00927.00635c.0058.00244.01288.00146.01874.00391a1.20844,1.20844,0,0,0,.93744-.00025l.01855-.00439.00666-.0044a1.20765,1.20765,0,0,0,.16632-.1123,1.1717,1.1717,0,0,0,.19659-.124c.005-.00463.00647-.01123.01135-.01611l.02717-.02783c.00445-.00488.0108-.00611.01519-.01074l4.90821-5.2295a1.24979,1.24979,0,1,0-1.82227-1.71093L7.42463,18.02148v-4.675A11.03794,11.03794,0,1,1,18.45783,24.5a1.25,1.25,0,0,0,0,2.5,13.50007,13.50007,0,1,0,0-27Z" id="interface-solid-multimedia-refresh-button" /></g></g></svg>
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td className="pro-match-update pl-20">
                                  <div className="d-flex flex-wrap custom-width-col-2">

                                    {frame.player2BallPoints && frame.player2BallPoints.map((ballsPoint, breakNumber) => {
                                      return (
                                        <Break
                                          player="2"
                                          key={breakNumber}
                                          balls={ballsPoint}
                                          breakNumber={breakNumber}
                                          frameNumber={frameNumber}
                                          ballIncrement={this.ballIncrement}
                                          ballDecrement={this.ballDecrement}
                                        />
                                      )
                                    })
                                    }

                                    <Break
                                      player="2"
                                      key={"addBreakPlayer2"}
                                      frameNumber={frameNumber}
                                      isBreakAdd={true}
                                      addBreak={this.addBreak}
                                    />
                                  </div>
                                  <div className="d-flex bottom align-items-center">
                                    Total Score : <span className="red-txt">   {frame.player2Score
                                      ? frame.player2Score
                                      : 0}</span>
                                    <span onClick={() => this.resetFrame(frameNumber, 2)}>
                                      <svg viewBox="0 0 31.99983 27"><g data-name="Layer 2" id="Layer_2"><g id="Interface-Solid"><path fill="#666666" d="M18.45783,0A13.53082,13.53082,0,0,0,4.92713,13.29712l-.0025.01245v.03662c-.00061.05176-.00781.10205-.00781.15381,0,.01367.00738.02515.00781.03857v4.48975L2.16,15.09277A1.25042,1.25042,0,1,0,.33967,16.80762l4.9248,5.22949c.00458.00488.01117.00635.01581.011l.0279.02734c.00469.00464.00616.011.011.01538a1.20328,1.20328,0,0,0,.18605.11743,1.21223,1.21223,0,0,0,.17328.1167l.00927.00635c.0058.00244.01288.00146.01874.00391a1.20844,1.20844,0,0,0,.93744-.00025l.01855-.00439.00666-.0044a1.20765,1.20765,0,0,0,.16632-.1123,1.1717,1.1717,0,0,0,.19659-.124c.005-.00463.00647-.01123.01135-.01611l.02717-.02783c.00445-.00488.0108-.00611.01519-.01074l4.90821-5.2295a1.24979,1.24979,0,1,0-1.82227-1.71093L7.42463,18.02148v-4.675A11.03794,11.03794,0,1,1,18.45783,24.5a1.25,1.25,0,0,0,0,2.5,13.50007,13.50007,0,1,0,0-27Z" id="interface-solid-multimedia-refresh-button" /></g></g></svg>
                                    </span>
                                    <div className="ml-auto">Foul Earned : <span className="text-green">{frame.player2FoulEarned && frame.player2FoulEarned.length > 0 ? frame.player2FoulEarned.reduce((acc, curr) => acc + curr, 0) : 0} Points</span></div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        )
                      })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  countryApiReducer: state.countryApiReducer,
  ui: state.ui,
  apiReducer: state.apiReducer,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(UpdateScore);

